<template>
    <v-card class="mx-auto"
            max-width="90%"
            elevation="10"
            >
        <v-list-item two-line>
            <v-list-item-content>
                <v-col cols="12">
                    <v-list-item-title class="text-h5">
                        {{ title }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        {{ desc }}
                    </v-list-item-subtitle>
                </v-col>
            </v-list-item-content>
        </v-list-item>
        <v-card-text>
            <v-row align="center">
                <v-col class="text-h4" cols="9">
                    {{ value }}
                </v-col>
                <v-col cols="3">
                    <v-icon
                        :color="iconColor"
                        x-large
                        >{{ icon }}</v-icon>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
    import axios from "axios";
    import { functions } from "../functions";
    import { EventBus } from "@/event-bus";

    export default {

        name: "DashboardDaeeCard1",

        components: {
        },

        props: {
            route: String,
            um: String,
            title: String,
            desc: String,
            dateStart: String,
            dateEnd: String,
            id: Number,
            update: Number
        },

        data: function () {
            return {
                rootApi: process.env.VUE_APP_ROOT_API,
                value: "-",
                icon: "",
                iconColor: "green"
            };
        },

        created: function () {
        },

        mounted: function () {
        },

        computed: {

        },

        watch: {
            update(newValue, oldValue) {
                this.wSDataRequest();
            }
        },

        afterCreate: function () {
        },

        beforeCreate: function () {

        },

        methods: {

            wSDataParseResponse(response) {
                this.value = parseFloat(response.value).toFixed(2) + this.um;
            },

            wSDataRequest() {
                const url = `${this.rootApi}/${this.route}/${this.id}/${this.parseDateToUrl(this.dateStart)}/${this.parseDateToUrl(this.dateEnd)}`;
                axios
                        .get(url, axios.getHeaders())
                        .then((response) => {
                            this.wSDataParseResponse(response.data);
                        })
                        .catch((err) => {
                            return functions.parseCatch(err, this.$appMessages.err404);
                        });
            },

            parseDateToUrl(date) {
                return date.replaceAll("/", "-");
            }
        }
    };
</script>

<style>

</style>
